import { PropsWithChildren } from 'react';
import { queryKeyHashFn } from '@silo/query';
import { QueryClient as ReactQueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new ReactQueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      queryKeyHashFn,
    },
  },
});

export const QueryClient = (props: PropsWithChildren<{}>) => {
  return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
};
